import { actionService } from '../services'

const state = {
  actions: [],
  action: null,
  itemsPerPage: 25,
  pagination: null,
  initialStatus: null,
  datatableParams: null,
  files: [],
  history: [],
  file: null
}

const getters = {
  getActions (state) {
    return state.actions
  },
  currentAction (state) {
    return state.action
  },
  pagination (state) {
    return state.pagination
  },
  getItemsPerPage (state) {
    return state.itemsPerPage
  },
  findAllFiles (state) {
    return state.files
  },
  findFile (state) {
    return state.file
  },
  getInitialStatus (state) {
    return state.initialStatus
  },
  getDatatableParams (state) {
    return state.datatableParams
  },
  findHistory (state) {
    return state.history
  }
}

const mutations = {
  create (state, item) {
    const foundAt = state.actions.findIndex(action => action.id === item.id)
    if (foundAt === -1) {
      state.actions.push(item)
    }
  },
  update (state, { id, item }) {
    const foundAt = state.actions.findIndex(action => action.id === id)
    state.actions.splice(foundAt, 1, item)
  },
  delete (state, id) {
    const index = state.actions.findIndex(action => action.id === id)

    if (index !== -1) {
      state.actions.splice(index, 1)
    }

    if (state.pagination) {
      state.pagination.totalItems = state.actions.length
    }
  },
  getAll (state, actions) {
    state.actions = actions
  },
  getEventActions (state, actions) {
    state.actions = actions
  },
  setActionsItemsPerPage (state, actionsItemsPerPage) {
    state.itemsPerPage = actionsItemsPerPage
  },
  resetCurrentAction (state) {
    state.action = null
  },
  find (state, action) {
    if (action.origin === null) {
      if (action.otherOrigin === null) {
        action.origin = { id: null, label: '' }
      } else {
        action.origin = { id: 'other', label: 'Autre' }
      }
    }

    if (action.recipient === null) {
      if (action.otherRecipient === null) {
        action.recipient = { id: null, label: '' }
      } else {
        action.recipient = { id: 'other', label: 'Autre' }
      }
    }

    state.initialStatus = action.status
    state.action = action
  },
  pagination (state, pagination) {
    state.pagination = pagination
  },
  findAllFiles (state, files) {
    state.files = files
  },
  removeFile (state, fileId) {
    const foundAt = state.files.findIndex(file => file.id === fileId)

    if (foundAt > -1) {
      state.files.splice(foundAt, 1)
    }
  },
  addFile (state, file) {
    state.files.push(file)
  },
  findFile (state, fileId) {
    state.file = state.action.attachments.find(file => file.id === fileId)
  },
  persistDatatableParams (state, params) {
    state.datatableParams = params
  },
  findHistory (state, history) {
    state.history = history
  }
}

const actions = {
  exportAction (context, { eventId, actionId, mapUrl, format }) {
    context.dispatch('loader/startLoading', 'action/export', { root: true })
    return actionService.exportAction(eventId, actionId, mapUrl, format)
      .catch(() => {
        context.dispatch('alert/error', `Echec de l'export de l'action ${actionId}.`, { root: true })
      })
      .finally(() => {
        context.dispatch('loader/stopLoading', 'action/export', { root: true })
      })
  },
  findAll (context) {
    return actionService.findAll()
      .then(response => {
        context.commit('getAll', response.data)
        return response
      })
  },
  findEventActions (context, params) {
    context.commit('persistDatatableParams', params)
    return actionService.findEventActions(params)
      .then(response => {
        context.commit('getEventActions', response.data.items)
        context.commit('pagination', response.data.pagination)
        return response
      })
  },
  find (context, { eventId, actionId }) {
    return actionService.find(eventId, actionId)
      .then(response => {
        context.commit('find', response.data)
        return response
      })
  },
  setActionsItemsPerPage (context, actionsItemsPerPage) {
    context.commit('setActionsItemsPerPage', actionsItemsPerPage)
  },
  resetCurrentAction (context) {
    context.commit('resetCurrentAction')
  },
  create (context, { eventId, action }) {
    context.dispatch('loader/startLoading', 'action/create', { root: true })
    return actionService.create(eventId, action)
      .then(response => {
        context.dispatch('alert/success', `Création réussie de l'action ${response.data.label}.`, { root: true })
        return response.data
      })
      .catch(() => {
        context.dispatch('alert/error', `Echec de la création de l'action ${action.label}.`, { root: true })
      })
      .finally(() => {
        context.dispatch('loader/stopLoading', 'action/create', { root: true })
      })
  },
  update (context, { eventId, actionId, action }) {
    context.dispatch('loader/startLoading', 'action/update', { root: true })
    return actionService.update(eventId, actionId, action)
      .then(response => {
        context.dispatch('action/findEventActions', context.state.datatableParams, { root: true })
        context.dispatch('alert/success', `Mise à jour réussie de l'action ${response.data.label}.`, { root: true })
        return response.data
      })
      .catch(() => {
        context.dispatch('alert/error', `Echec de la mise à jour de l'action ${action.label}.`, { root: true })
      })
      .finally(() => {
        context.dispatch('loader/stopLoading', 'action/update', { root: true })
      })
  },
  delete (context, { actionId, eventId }) {
    return actionService.deleteAction(eventId, actionId)
      .then(response => {
        context.commit('delete', actionId)
        return response
      })
  },
  findAllFiles (context, files) {
    context.commit('findAllFiles', files)
  },
  removeFile (context, { eventId, actionId, fileId }) {
    return actionService.removeFile(eventId, actionId, fileId)
      .then(() => {
        context.commit('removeFile', fileId)
        context.dispatch('alert/success', 'La pièce jointe a bien été supprimée', { root: true })
      })
      .catch(() => {
        context.dispatch('alert/error', 'La suppression de la pièce jointe a échoué.', { root: true })
      })
  },
  findFile (context, fileId) {
    context.commit('findFile', fileId)
  },
  findHistory (context, { eventId, actionId }) {
    return actionService.findHistory(eventId, actionId)
      .then(response => {
        context.commit('findHistory', response.data)
        return response
      })
  }
}

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions
}
